/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InventoryDTOFromJSON, InventoryDTOToJSON, } from './InventoryDTO';
/**
 * Check if a given object implements the PaginatedResponseInventoryDTO interface.
 */
export function instanceOfPaginatedResponseInventoryDTO(value) {
    return true;
}
export function PaginatedResponseInventoryDTOFromJSON(json) {
    return PaginatedResponseInventoryDTOFromJSONTyped(json, false);
}
export function PaginatedResponseInventoryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(InventoryDTOFromJSON)),
    };
}
export function PaginatedResponseInventoryDTOToJSON(json) {
    return PaginatedResponseInventoryDTOToJSONTyped(json, false);
}
export function PaginatedResponseInventoryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(InventoryDTOToJSON)),
    };
}
